module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_score.8758c.png";